import React, { useEffect, useState } from "react";
import Breadcrumbs from "../../../customComponent/BreadCrumbs";
import {
  breadcrumbNameMap,
  errorMessages,
  ImageBaseUrl,
} from "../../../utils/helperData";
import { AiOutlineDownload } from "react-icons/ai";
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate } from "react-router";
import { VIEW_MANAGE_PROJECT_DETAILS } from "../../../utils/RouteConstant";
import FormSection from "../../../customComponent/FormSection/FormSection";
import FormField from "../../../customComponent/FormField/FormField";
import { useDispatch, useSelector } from "react-redux";
import { GetWeldLogDetails } from "../../../../redux/action/InspectionDetails/InspectionDetailsAction";
import WeldInspectionTable from "./WeldInspectionTable";
import { MdError } from "react-icons/md";
import frame_Icon from "../../../../asesst/file_image.png";
import NonWeldedInspectionTable from "./NonWeldedMaterialTable";

const ViewDetailsISOWeldLog = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { inspectionDetaildata } = useSelector(
    (state) => state.inspectionDetails
  );
   const projectDetails = useSelector((state) => state.project.projectDetails);
  const [showTooltip, setShowTooltip] = useState(false);
  const projectId = location.state?.data?.project_id;
  useEffect(() => {
    if (location.state?.data?._id && projectId) {
      dispatch(GetWeldLogDetails(location.state.data._id, projectId));
    }
  }, [dispatch, location.state?.data?._id, projectId]);

  if (!inspectionDetaildata) {
    console.log("Data is still loading...");
    return <div>Loading...</div>;
  }

  const handleGoBack = () => {
    navigate(
      `${VIEW_MANAGE_PROJECT_DETAILS}/${inspectionDetaildata?.project?._id}`,
      {
        state: {
          selectedTab: "Inspection Details",
          selectedInspectionIndex: 4,
        },
        replace: true,
      }
    );
  };

  const renderFormField = (label, value, isValid) => {
    return (
      <div className="flex items-center mb-4">
        <FormField
          label={label}
          value={value}
          className={!isValid ? "text-red-500" : ""}
        />
        {!isValid && (
          <div
            className="relative ml-2 text-red-500 top-3 right-2 transform -translate-y-1/2"
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <MdError className="text-red-500" />
            {showTooltip && (
              <div className="absolute z-10 bg-red-100 text-red-800 p-2 rounded-md shadow-lg text-xs">
                {errorMessages?.is_draw_no_valid}
              </div>
            )}
          </div>
        )}
      </div>
    );
  };

  const baseUrl = ImageBaseUrl;
  const handleDownload = (e, fileUrl, fileName) => {
    e.preventDefault();
    fetch(fileUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => alert("An error occurred while downloading the file."));
  };

  const truncateString = (str) => {
    if (str?.length > 15) {
      return str.slice(0, 15) + "...";
    }
    return str;
  };
  const renderDocumentSection = () => {
    const { document } = inspectionDetaildata || {};

    if (!document || document.length === 0) return null;

    const renderDocumentItem = (doc, index) => (
      <div
        key={index}
        className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
      >
        <div className="flex items-center space-x-3">
          <img
            src={frame_Icon}
            alt="Inspector Document"
            className="w-12 h-12 rounded-lg"
          />
          <div>
            <p className="font-semibold">
              {truncateString(doc.name || "Document")}
            </p>
          </div>
        </div>
        <button
          className="text-[#1C3664]"
          onClick={(e) => handleDownload(e, `${baseUrl}${doc}`, doc)}
        >
          <AiOutlineDownload size={24} />
        </button>
      </div>
    );

    return <FormSection>{document.map(renderDocumentItem)}</FormSection>;
  };

    const renderImageSection = () => {
      const { images } = inspectionDetaildata || {};

      if (!images || images?.length === 0) return null;

      const renderDocumentItem = (doc, index) => (
        <div
          key={index}
          className="flex items-center justify-between p-4 border border-gray-200 rounded-lg"
        >
          <div className="flex items-center space-x-3">
            <img
              src={frame_Icon}
              alt="Inspector Document"
              className="w-12 h-12 rounded-lg"
            />
            <div>
              <p className="font-semibold">
                {truncateString(doc?.name || "Images")}
              </p>
            </div>
          </div>
          <button
            className="text-[#1C3664]"
            onClick={(e) => handleDownload(e, `${baseUrl}${doc}`, doc)}
          >
            <AiOutlineDownload size={24} />
          </button>
        </div>
      );

      return <FormSection>{images.map(renderDocumentItem)}</FormSection>;
    };

  return (
    <div>
      <div className="mb-6">
        <h2 className="text-3xl font-bold mb-6">Isometric Weld Logs</h2>
        <div className="flex justify-between items-center">
          <Breadcrumbs breadcrumbNameMap={breadcrumbNameMap} />
          <div className="flex gap-2 items-center">
            {projectDetails?.document && (
              <img
                src={`${ImageBaseUrl}${projectDetails.document}`}
                alt="not"
                className="preview-image w-[3.5rem] h-12 bg-cover bg-center rounded-3xl mr-2.5"
              />
            )}
            <span className="text-xl font-semibold">
              Project Name:-
              <span className="text-blue-500">
                {" "}
                {projectDetails?.name || location?.state?.data?.project_name}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="mx-auto bg-white shadow-lg rounded-lg p-8">
        <div className="flex items-center justify-between text-2xl font-base font-poppins mb-8 text-[#202224]">
          <div className="flex items-center">
            <FaArrowLeft className="cursor-pointer" onClick={handleGoBack} />
            <h3
              className="text-lg p-2 font-semibold cursor-pointer"
              onClick={handleGoBack}
            >
              Go Back
            </h3>
          </div>
          <div className="text-2xl p-2 font-semibold">
            Total Error Count: {inspectionDetaildata?.form_error_count}
          </div>
        </div>
        <FormSection title="Inspection Data">
          {renderFormField(
            "Isometric Drawing Number",
            inspectionDetaildata?.iso_draw_no,
            inspectionDetaildata?.is_draw_no_valid
          )}
          {renderFormField(
            "Line Class",
            inspectionDetaildata?.line_class,
            true
          )}
          {renderFormField("P & ID", inspectionDetaildata?.p_id, true)}
          {renderFormField("Line Number", inspectionDetaildata?.line_no, true)}
          {renderFormField("Other", inspectionDetaildata?.other, true)}
          {renderFormField("System", inspectionDetaildata?.system, true)}
        </FormSection>
        <FormSection title="Weld Inspection" />
        <WeldInspectionTable inspectionDetaildata={inspectionDetaildata} />
        <br /> <br /> <br />
        <FormSection title="Non-Welded Materials" />
        <NonWeldedInspectionTable inspectionDetaildata={inspectionDetaildata} />
        {renderDocumentSection()}
        {renderImageSection()}
      </div>
    </div>
  );
};

export default ViewDetailsISOWeldLog;
